export const setNavBarState = () => {
  document.body.classList.toggle('disable-scroll');
  return {
    type: 'SET_NAVBAR_STATE'
  };
};


export const setTheme = (theme) => {
  document.body.classList.add(theme.toLowerCase());
  return {
    type: 'SET_THEME',
    payload: theme
  };
};



// WEBPACK FOOTER //
// ./src/actions/layoutActions.js